import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { ShapeEditorActorContext } from 'app/agriculture/forms/components/ShapeEditor/ShapeEditorMachine';

interface ShapeEditorHelpTextProps {
    infraType: InfraType;
    canRemovePoint: boolean;
}
export function ShapeEditorHelpText({ infraType, canRemovePoint }: ShapeEditorHelpTextProps) {
    const isEditing = ShapeEditorActorContext.useSelector((state) => state.matches('Editing'));

    const { mode, selectedPointIndex } = ShapeEditorActorContext.useSelector(
        (state) => state.context,
    );

    if (!isEditing) {
        return `Create a ${infraType.toLowerCase()} by drawing at least ${mode === 'Polygon' ? 'three' : 'two'} points${mode === 'Polygon' ? ' and closing the shape.' : '.'}`;
    }
    if (selectedPointIndex === -1) {
        return 'Select a point to edit. Selected points can be moved or removed.';
    }
    if (canRemovePoint) {
        return 'Point selected - Drag the point to change its position or delete this point with the button below.';
    }
    return `Point selected - Drag the point to change its position. You can't remove a point from a ${infraType.toLowerCase()} with ${mode === 'Polygon' ? 'three' : 'two'} or less points.`;
}
